export default "__VITE_ASSET__5yUYQ3yF__"